var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "bond-preview-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.dialogTitle,
        width: _vm.dialogWidth,
        "show-close": true,
        "close-on-click-modal": true,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "preview-content" }, [
        _vm.loading
          ? _c("div", { staticClass: "loading-container" }, [
              _c("i", { staticClass: "el-icon-loading loading-icon" }),
              _c("span", [_vm._v("加载中...")])
            ])
          : _vm.error
          ? _c("div", { staticClass: "error-container" }, [
              _c("i", { staticClass: "el-icon-error error-icon" }),
              _c("span", [_vm._v(_vm._s(_vm.error))])
            ])
          : _c("div", { staticClass: "file-content" }, [
              _vm.pdfSrc
                ? _c(
                    "div",
                    { staticClass: "pdf-container" },
                    _vm._l(_vm.numPages, function(i) {
                      return _c("pdf", {
                        key: i,
                        attrs: { src: _vm.pdfSrc, page: i }
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm.wordSrc
                ? _c(
                    "div",
                    { staticClass: "office-wrapper word-wrapper" },
                    [
                      _c("vue-office-docx", {
                        style: { width: "100%", height: "500px" },
                        attrs: { src: _vm.wordSrc, "page-width": "100%" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.excelSrc
                ? _c("div", { staticClass: "office-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "office-container" },
                      [
                        _c("vue-office-excel", {
                          style: {
                            width: "100%",
                            minWidth: "1200px",
                            height: "500px"
                          },
                          attrs: { src: _vm.excelSrc }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.imgUrl
                ? _c("div", { staticClass: "image-wrapper" }, [
                    _c(
                      "div",
                      { staticClass: "image-controls" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.zoomOut }
                          },
                          [_c("i", { staticClass: "el-icon-minus" })]
                        ),
                        _c("span", { staticClass: "zoom-value" }, [
                          _vm._v(_vm._s(_vm.zoomLevel) + "%")
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.zoomIn }
                          },
                          [_c("i", { staticClass: "el-icon-plus" })]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: { click: _vm.resetZoom }
                          },
                          [_vm._v("重置")]
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "image-container" }, [
                      _c("img", {
                        style: {
                          transform: "scale(" + _vm.zoomLevel / 100 + ")",
                          transformOrigin: "center center"
                        },
                        attrs: { src: _vm.imgUrl, alt: _vm.fileName }
                      })
                    ])
                  ])
                : _vm._e(),
              _vm.txtPre
                ? _c("div", { staticClass: "txt-container" }, [
                    _c("pre", [_vm._v(_vm._s(_vm.txtPre))])
                  ])
                : _vm._e(),
              !_vm.pdfSrc &&
              !_vm.wordSrc &&
              !_vm.excelSrc &&
              !_vm.imgUrl &&
              !_vm.txtPre
                ? _c("div", { staticClass: "unsupported-container" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _c("span", [_vm._v("暂不支持此文件类型预览，请下载查看")])
                  ])
                : _vm._e()
            ])
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [_c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("关闭")])],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }